module.exports = __webpack_public_path__ + "img/探见读书日.aad933ea.jpg";